/** Runtime config sourced from Vite env vars (see .env.example). */

function required(name: string, value: string | undefined): string {
  if (!value) {
    // Surface misconfiguration loudly in dev; in prod the build injects values.
    console.warn(`Missing env ${name}`);
  }
  return value ?? "";
}

export const config = {
  apiBaseUrl: required("VITE_API_BASE_URL", import.meta.env.VITE_API_BASE_URL),
  cognitoDomain: required(
    "VITE_COGNITO_DOMAIN",
    import.meta.env.VITE_COGNITO_DOMAIN,
  ),
  cognitoClientId: required(
    "VITE_COGNITO_CLIENT_ID",
    import.meta.env.VITE_COGNITO_CLIENT_ID,
  ),
  appUrl: required("VITE_APP_URL", import.meta.env.VITE_APP_URL),
  googleMapsBrowserKey: import.meta.env.VITE_GOOGLE_MAPS_BROWSER_KEY ?? "",
  /** Redirect URI registered in Cognito for the SPA. */
  get redirectUri() {
    return `${this.appUrl}/auth/callback`;
  },
};
